
export function CommunitySection() {
  const features = [
    {
      icon: 'ri-group-line',
      title: 'Comunidad Activa 24/7',
      description: 'Conecta con emprendedores que comparten tus mismos objetivos y desafíos',
    },
    {
      icon: 'ri-question-answer-line',
      title: 'Soporte Directo',
      description: 'Obtén respuestas rápidas de mentores y compañeros experimentados',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Retos y Gamificación',
      description: 'Participa en desafíos semanales y gana recompensas por tu progreso',
    },
    {
      icon: 'ri-live-line',
      title: 'Sesiones en Vivo',
      description: 'Clases exclusivas, Q&A y masterclasses con expertos del sector',
    },
    {
      icon: 'ri-share-line',
      title: 'Comparte tus Resultados',
      description: 'Celebra tus victorias y aprende de las experiencias de otros miembros',
    },
  ];

  const stats = [
    { value: '500+', label: 'Miembros Activos' },
    { value: '100+', label: 'Posts Diarios' },
    { value: '24/7', label: 'Soporte' },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          alt=""
          className="w-full h-full object-cover object-center mix-blend-screen"
          src="https://public.readdy.ai/ai/img_res/788e4e68ab777c4ed94bfe1a17826648.jpg"
        />
      </div>
      <div className="absolute top-10 right-10 sm:top-20 sm:right-20 w-32 h-32 sm:w-48 sm:h-48 lg:w-64 lg:h-64 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-10 left-10 sm:bottom-20 sm:left-20 w-40 h-40 sm:w-60 sm:h-60 lg:w-80 lg:h-80 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full blur-3xl opacity-20"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12 space-y-3 sm:space-y-4">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
            <i className="ri-community-line text-emerald-400 text-lg sm:text-xl"></i>
            <span className="text-white text-xs sm:text-sm font-semibold whitespace-nowrap">Comunidad Exclusiva</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-white leading-tight">
            En Nuestra Academia en <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Skool</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-white/80 leading-relaxed">
            Únete a una comunidad vibrante donde aprenderás, compartirás y crecerás junto a otros emprendedores digitales
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                alt="Academia en Skool"
                className="w-full h-auto object-cover object-top"
                src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/dfe663df6d25069acc2c87f0fcf0980c.png"
              />
            </div>
            <div className="absolute -bottom-3 -right-3 sm:-bottom-6 sm:-right-6 w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full blur-3xl opacity-60 animate-pulse"></div>
            <div className="absolute -top-3 -left-3 sm:-top-6 sm:-left-6 w-24 h-24 sm:w-32 sm:h-32 lg:w-40 lg:h-40 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full blur-3xl opacity-40 animate-pulse"></div>
          </div>

          <div className="space-y-6 order-1 lg:order-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-11 sm:h-11 lg:w-12 lg:h-12 rounded-lg sm:rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-emerald-400 text-lg sm:text-xl lg:text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg lg:text-xl font-bold text-white mb-1 sm:mb-2">{feature.title}</h3>
                    <p className="text-xs sm:text-sm lg:text-base text-white/70 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap justify-center sm:justify-start gap-4 sm:gap-6 pt-4">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
